module.exports = __webpack_public_path__ + "static/media/blankImage.13aa92ef.svg";